// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingAnimation_keto_container__2UJ50","logo":"LoadingAnimation_keto_logo__3OZWf","text":"LoadingAnimation_keto_text__3eIVi"};